import { CircularProgress } from "@mui/material";
import React from "react";
import Chart from "react-apexcharts";

const CustomChart = ({ data, isLoading }) => {
  // Check if data is available
  const hasData =
    data?.series &&
    data?.series.length > 0 &&
    data?.series.some((val) => val > 0);

  // Default "No Data" chart
  const noDataChart = {
    series: [100],
    labels: ["No Data"],
    colors: ["#d9d9d9"],
  };

  return (
    <div
      style={{
        display: "flex",
        overflow: "hidden",
        justifyContent:'center',
        alignItems: 'center',
        width: "100%",
        height: "316px",
        border: "1px solid rgb(217, 217, 217)",
        borderRadius: "8px",
        padding: "16px 0px",
        backgroundColor: "white",
      }}
    >
      {
        isLoading ? <CircularProgress sx={{ color: 'black' }} size={26} /> :
          (
            <div style={{ width: "100%", height: "100%" }}>
              <Chart
                type="pie"
                className="dashboard-analytics"
                series={hasData ? data?.series : noDataChart.series}
                options={{
                  chart: {
                    type: "pie",
                    animations: { enabled: true },
                    dynamicAnimation: { enabled: true },
                  },
                  labels: hasData ? data?.options?.labels : noDataChart.labels,
                  colors: hasData ? data?.options?.colors : noDataChart.colors,
                  // Added to disable hover/active filter effects
                  states: {
                    hover: {
                      filter: {
                        type: "none",
                      },
                    },
                    active: {
                      filter: {
                        type: "none",
                      },
                    },
                  },
                  dataLabels: {
                    style: { fontSize: "10px" },
                    dropShadow: {
                      enabled: true,
                      top: 1,
                      left: 1,
                      blur: 2,
                      color: "#000",
                      opacity: 0.5,
                    },
                  },
                  title: {
                    text: data?.title,
                    align: "center",
                    offsetY: -2,
                    style: {
                      fontSize: "15px",        // Larger size
                      fontWeight: 600,         // Bolder
                      fontFamily: "Arial, sans-serif",  // Clean font
                      color: "#1f1f1f",        // Darker shade for contrast
                    },
                  },
                  legend: {
                    position: "right",
                    fontSize: "10px",
                    labels: { useSeriesColors: true },
                    markers: { width: 10, height: 10 },
                    itemMargin: { vertical: 2 },
                    width: "100",
                  },
                  plotOptions: {
                    pie: {
                      dataLabels: { offset: -5 },
                    },
                  },
                }}
                width="100%"
                height="70%"
              />

              {/* Text for Valid Transactions, Excluded Transactions, and Processed Transactions */}
              {data?.title === "Records" && (
                <div
                  style={{
                    textAlign: "left",
                    padding: "0px 16px",
                  }}
                >
                  <p style={{ margin: 0, fontSize: "12px", color: "#353535" }}>
                    Valid Transactions:{" "}
                    <b style={{ fontSize: "12px" }}>
                      {hasData ? data?.series[0] ?? 0 : 0}
                    </b>
                  </p>
                  <p style={{ margin: 0, fontSize: "12px", color: "#353535" }}>
                    Excluded Transactions:{" "}
                    <b style={{ fontSize: "12px" }}>
                      {hasData ? data?.series[1] ?? 0 : 0}
                    </b>
                  </p>
                  <p style={{ margin: 0, fontSize: "12px", color: "#353535" }}>
                    Errors Detected:{" "}
                    <b style={{ fontSize: "12px" }}>
                      {hasData ? data?.series[2] ?? 0 : 0}
                    </b>
                  </p>
                  <p style={{ margin: 0, fontSize: "12px", color: "#353535" }}>
                    Ineligible Transactions:{" "}
                    <b style={{ fontSize: "12px" }}>
                      {hasData ? data?.series[3] ?? 0 : 0}
                    </b>
                  </p>
                  <p style={{ margin: 0, fontSize: "12px", color: "#353535" }}>
                    Processed Transactions:{" "}
                    <b style={{ fontSize: "12px" }}>
                      {(hasData ? data?.series[0] ?? 0 : 0) +
                        (hasData ? data?.series[1] ?? 0 : 0) +
                        (hasData ? data?.series[2] ?? 0 : 0) +
                        (hasData ? data?.series[3] ?? 0 : 0)}
                    </b>
                  </p>
                </div>
              )}


              {/* Text for Total Number of Record Type Data, Source System Data, Product Data */}
              {["Record Type", "Source System", "Product"].includes(data?.title) && (
                <div
                  style={{
                    marginTop: "10px",
                    textAlign: "left",
                    padding: "0px 16px",
                  }}
                >
                  <p style={{ margin: 0, fontSize: "12px", color: "#353535" }}>
                    {"Total Number Of " + data?.title + ": "}
                    <b style={{ fontSize: "12px" }}>
                      {hasData ? data?.options?.labels?.length ?? 0 : 0}
                    </b>
                  </p>
                </div>
              )}
            </div>
          )

      }

    </div>
  );
};

export default CustomChart;
